<template>
  <div
    class="fattutto-index-transmissions mx-1"
    v-if="canVerb('fattutto', 'config')"
  >
    <actions-toolbar>
      <template #filters>
        <div class="status-filter">
          <div class="pill-wrapper my-3">
            <span
              class="pill"
              v-for="(value, name, index) in activeFilters"
              :key="index"
              data-color="white"
            >
              <span v-b-toggle.sidebar-1 :data-filter="name"
                ><strong>{{ sidebarFilterName(name) }}</strong
                >:&nbsp;{{ sidebarFilterValue(name, value) }}</span
              >
              <span tabindex="0">
                <span
                  @click="resetSingleSidebarFilter(name)"
                  title="Rimuovi filtro"
                  >×</span
                >
              </span>
            </span>
            <template v-if="countActiveFilters">
              <span
                class="pill"
                data-color="alert"
                @click="resetAllFilters()"
                title="Rimuovi i filtri e apri il pannello per una nuova ricerca"
              >
                <span
                  ><strong>Reset ({{ countActiveFilters }})</strong></span
                >
                <span><span>×</span></span>
              </span>
            </template>
          </div>
        </div>
      </template>
      <b-button-group
        v-b-toggle.sidebar-1
        :class="`filter-button-group btn--smaller btn--transparent align-items-center gap-3${
          countActiveFilters ? ' active' : ''
        }`"
        :title="getDefaultFilterMessage()"
      >
        <base-icon name="filters" width="23" height="23" />
        <span style="font-size: 14px; font-weight: 500">{{
          computedFilterTitle
        }}</span>
      </b-button-group>
    </actions-toolbar>
    <div class="table-container">
      <b-sidebar
        id="sidebar-1"
        :title="computedFilterTitle"
        :backdrop="true"
        width="50dvw"
        shadow
        right
        :visible="open_filter"
        :data-open="open_filter"
        @change="onSidebarFilterChange"
      >
        <b-form @submit.prevent="onSearch(filterName)">
          <div class="filter">
            <div class="filter-item">
              <base-select
                name="entity_type"
                vid="entity_type"
                label="Entità"
                :options="configurable_type"
                v-model="filter.configurable_type"
              />
            </div>
            <div class="filter-item">
              <base-input
                name="fattutto_code"
                vid="fattutto_code"
                label="Codice Fattutto"
                placeholder="Inserisci un codice"
                v-model="filter.code"
              />
            </div>
          </div>
          <div class="actions-filter-sidebar-wrapper">
            <b-button
              type="submit"
              variant="lisaweb"
              size="sm"
              v-b-toggle:sidebar-1
              >Cerca
            </b-button>
            <b-button
              class="btn--transparent btn-reset"
              type="button"
              size="sm"
              @click="onClearFilter(filterName)"
              >Reset
            </b-button>
          </div>
        </b-form>
      </b-sidebar>
      <fattutto-configuration-table
        :fields="fields"
        @manualFetch="manualFetch"
        :performedSearch="computePerformedSearch"
        :filterCount="countActiveFilters"
        :items="items"
        :repository="repository"
        :resource="resource"
        :filterName="filterName"
        :ref="tableRef"
        @forcedFetch="forcedFetch"
      ></fattutto-configuration-table>
    </div>
  </div>
  <div v-else class="mt-3">
    <b-icon icon="info-circle" scale="1.00"></b-icon>
    Non hai i permessi
  </div>
</template>

<script>
// import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import CustomFiltersMixin from "@/mixins/CustomFiltersMixin";
import FattuttoConfigurationTable from "@/components/tables/FattuttoConfiguration.vue";
import FormMixin from "@/mixins/FormMixin";
import BaseInput from "@/components/form/BaseInput";
import BaseSelect from "@/components/form/BaseSelect";
import { mapActions } from "vuex";
import { toLocaleDate } from "@/utils/dates";
import moment from "moment";

moment.locale("it");
import { canVerb } from "@/utils/permissions";
import BaseIcon from "@/components/BaseIcon";
import SidebarFilterMixin from "../../../mixins/SidebarFilterMixin";

export default {
  mixins: [CustomFiltersMixin, FormMixin, SidebarFilterMixin],
  data() {
    return {
      isLoading: false,
      repository: "fattutto",
      resource: "config",
      tableRef: "FattuttoConfigTableRef",
      current_config: {},
      performedSearch: false,
      filterName: "filterFattuttoConfig",
      filter: this.initFilter(),
      configurable_type: [
        {
          value: "variousAccounting",
          text: "Causale contabile movimenti vari",
        },
        { value: "insurer", text: "Compagnia" },
        { value: "sector", text: "Comparto contabile" },
        { value: "broker", text: "Produttore" },
      ],
      fields: [
        {
          key: "actions",
          label: "",
          thClass: "align-middle",
          thStyle: {
            width: "20px",
            //width: `${20 * this.actions.length}px`,
          },
          tdClass: "bg-light actions",
        },
        {
          key: "configurable_type",
          label: this.getDictionary("entity", "fattutto"),
          formatter: (value) => this.renderConfigurableTypeLabel(value),
          sortable: true,
          sortKey: "configurable_type",
        },
        {
          key: "configurable.code",
          label: this.getDictionary("entity_code", "fattutto"),
        },
        {
          key: "active",
          label: this.getDictionary("active", "fattutto"),
          formatter: (value) => this.renderActiveLabel(value),
        },
        {
          key: "code",
          label: this.getDictionary("code", "fattutto"),
          formatter: (value) => (value ? value : "-"),
          sortable: true,
          sortKey: "code",
        },
        {
          key: "ledger_type",
          label: this.getDictionary("ledger_type", "fattutto"),
          formatter: (value) => this.renderLedgerTypeLabel(value),
        },
        {
          key: "ledger_code",
          label: this.getDictionary("ledger_code", "fattutto"),
          formatter: (value) => (value != null ? value : "-"),
        },
        {
          key: "negative_code",
          label: this.getDictionary("negative_code", "fattutto"),
          formatter: (value) => (value != null ? value : "-"),
        },
      ],
      items: [],
      transmission_status: {
        "-1": "Errore",
        0: "Creato",
        1: "Pronto per la trasmissione",
        2: "In corso",
        3: "Completato",
        4: "Completato con errori",
        5: "In coda",
        6: "Caricamento dati",
      },
    };
  },
  components: {
    BaseIcon,
    BaseInput,
    BaseSelect,
    FattuttoConfigurationTable,
  },
  computed: {
    countActiveFilters() {
      return Object.keys(this.activeFilters).length;
    },
    computedFilterTitle() {
      return `Filtri${
        this.countActiveFilters ? ` (${this.countActiveFilters})` : ""
      }`;
    },
    computePerformedSearch() {
      return this.performedSearch;
    },
  },
  methods: {
    canVerb,
    toLocaleDate,
    initFilter() {
      let init = {
        configurable_type: null,
        code: null,
      };
      return init;
    },
    // customFilterName(key, prefix = "byAttribute") {
    //   return `${prefix}.${key}`;
    // },
    manualFetch() {
      this.resetAllFilters();
    },
    retriveActiveFilters(obj = this.filter, parentKey = "") {
      for (const key in obj) {
        const value = obj[key];
        // Build the property path (for nested properties)
        const fullPath = parentKey ? `${parentKey}.${key}` : key;

        if (key === "byCustom" && typeof value === "object") {
          // Special handling for `byCustom`: Return everything in the inner object only if `value` is not null
          for (const innerKey in value) {
            const innerValue = value[innerKey];
            if (
              innerValue &&
              typeof innerValue === "object" &&
              "value" in innerValue
            ) {
              /* By default "value" is euqal to `null`, after it's been filled and being consequently emptied it's equal to an empty string */
              if (!(innerValue.value === null || innerValue.value === "")) {
                this.activeFilters[`${fullPath}.${innerKey}.value`] =
                  innerValue.value;
              }
            }
          }
        } else if (value && Array.isArray(value)) {
          if (value.length === 1) {
            this.activeFilters[fullPath] = value[0];
          } else if (value.length > 1) {
            // If it's an array don't print all the values recorsively
            this.activeFilters[fullPath] = `${value.length} selezioni`;
          }
        } else if (value && typeof value === "object") {
          // Recursively process nested objects for non-`byCustom` keys
          Object.assign(
            this.activeFilters,
            this.retriveActiveFilters(value, fullPath),
          );
        } else if (value !== null && String(value).length) {
          // Append non-null values
          this.activeFilters[fullPath] = value;
        }
      }
      return this.activeFilters;
    },
    onSearch(name) {
      this.performedSearch = true;
      this.activeFilters = {};
      this.activeFilters = this.retriveActiveFilters();
      //   if (
      //     typeof this.filter?.byAttribute?.setup_at !== "undefined" &&
      //     this.filter?.byAttribute?.setup_at !== null
      //   ) {
      //     const setup_at_moment = moment(this.filter.byAttribute.setup_at).format(
      //       "YYYY-MM"
      //     );
      //     this.setupAtMoment = this.filter.byAttribute.setup_at;
      //     this.filter.byAttribute.setup_at = setup_at_moment;
      //   }
      let criteria = this.filter;
      this.saveFilterByName({ name, criteria });
      this.removePaginationByName(name);
      this.$refs[this.tableRef].currentPage = 1;
      this.$refs[this.tableRef].fetch(this.current_config);
    },
    onClearFilter(name) {
      this.resetFilter();
      this.resetPagination();
      this.removeFilterByName(name);
      this.removePaginationByName(name);
      this.removeSortByName(name);
      this.$refs[this.tableRef].sortBy = "";
      this.$refs[this.tableRef].sortDesc = false;
    },
    ...mapActions("filters", {
      saveFilterByName: "saveByName",
      removeFilterByName: "removeByName",
    }),
    ...mapActions("pagination", { removePaginationByName: "removeByName" }),
    ...mapActions("sorts", {
      removeSortByName: "removeByName",
    }),
    onSaveFilter(name, criteria) {
      this.saveFilterByName({ name, criteria });
    },
    // onRefreshContent(name) {
    forcedFetch() {
      this.$refs[this.tableRef].fetch(this.current_config);
    },
    renderConfigurableTypeLabel(entity) {
      let ret = "";
      switch (entity) {
        case "App\\Models\\Insurer":
          ret = "Compagnia";
          break;
        case "App\\Models\\Broker":
          ret = "Produttore";
          break;
        case "App\\Models\\VariousAccounting":
          ret = "Causale contabile movimenti vari";
          break;
        case "App\\Models\\Sector":
          ret = "Comparto contabile";
          break;
        default:
          console.log("No entity matched!");
          break;
      }
      return ret;
    },
    renderActiveLabel(status) {
      return status === 1 ? "Sì" : "No";
    },
    renderLedgerTypeLabel(type) {
      let ret = "";
      switch (type) {
        case 0:
          ret = "Compagnia";
          break;
        case 1:
          ret = "Produttore";
          break;
        case 2:
          ret = "Codice";
          break;
        case 3:
          ret = "-";
          break;
        default:
          console.log("type entity matched!");
          break;
      }
      return ret;
    },
    // transmissionActionsEnd() {
    //   this.onRefreshContent();
    // },
    // onRefreshContent() {
    //   // let criteria = this.filter;
    //   // this.saveFilterByName({ name, criteria });
    //   this.$refs[this.tableRef].fetch(this.current_config);
    // },
  },
  created() {
    // const Repo = RepositoryFactory.get("fattutto");
    // this.isLoading = true;
    // Repo.index_transmission()
    //   .then((response) => {
    //     console.log("response", response);
    //     debugger;
    //     this.items = response?.data?.data ?? [];
    //   })
    //   .catch((error) => {
    //     let errMsg = this.$getErrorMessage(error);
    //     this.$showSnackbar({
    //       preset: "error",
    //       text: `${errMsg}`,
    //     });
    //   })
    //   .finally(() => {
    //     this.isLoading = false;
    //   });
  },
  mounted() {
    this.current_config.verb = {
      name: "configuration",
      canVerb: this.canVerb("fattutto", "config"),
    };
    this.$refs[this.tableRef].fetch(this.current_config);
  },
};
</script>
